export const mainNavigation = [
  {
    key: "dashboard",
    label: "Übersicht",
    icon: "fa-house",
    routeName: "Dashboard",
  },
  {
    key: "work",
    label: "Arbeitsbereich",
    icon: "fa-briefcase",
    items: [
      {
        key: "jobs",
        label: "Aufträge",
        icon: "fa-clipboard",
        routeName: "Aufträge",
        badge: "jobs",
      },
      {
        key: "tasks",
        label: "Aufgaben",
        icon: "fa-list-check",
        routeName: "Tasks",
        badge: "tasks",
        requiresInternalDispo: true,
      },
    ],
  },
  {
    key: "communication",
    label: "Kommunikation",
    icon: "fa-comment",
    items: [
      {
        key: "messages",
        label: "Nachrichten",
        icon: "fa-comments",
        routeName: "Chats",
        badge: "messages",
        requiresAdvanced: true,
      },
    ],
  },
  {
    key: "documents",
    label: "Unterlagen",
    icon: "fa-folder-open",
    items: [
      {
        key: "archive",
        label: "Archiv",
        icon: "fa-business-time",
        routeName: "Archiv",
      },
      {
        key: "documents",
        label: "Dokumente",
        icon: "fa-folder",
        routeName: "Documents",
      },
    ],
  },
  {
    key: "profile",
    label: "Profil",
    icon: "fa-user",
    items: [
      {
        key: "id",
        label: "Dienstausweis",
        icon: "fa-id-card",
        routeName: "Dienstausweis",
      },
      {
        key: "settings",
        label: "Einstellungen",
        icon: "fa-gear",
        routeName: "Einstellungen",
      },
    ],
  },
  {
    key: "admin",
    label: "Admin-Bereich",
    icon: "fa-sliders",
    routeName: "Admincenter",
    requiresAdvanced: true,
  },
  {
    key: "on-call",
    label: "Rufbereitschaft",
    icon: "fa-phone",
    href: "tel:+492233402850",
  },
];
